/*
  AdvancedFiltersContainer.js - Component to house filter options
*/

// NPM
import React, { useState } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const AdvancedFiltersContainer = ({
  children,
  open = null,
  setOpen = null,
}) => {
  const [openFilters, setOpenFilters] = useState(open);

  const toggleFilters = () => {
    if (open && setOpen) {
      setOpen(!open);
    } else {
      setOpenFilters(!openFilters);
    }
  };

  return (
    <Box>
      <Button
        onClick={toggleFilters}
        endIcon={open || openFilters ? <ExpandLess /> : <ExpandMore />}
        color="secondary"
        sx={{
          marginTop: 2,
          fontWeight: 400,
          textTransform: 'none',
          textDecoration: 'underline',
          paddingX: 2,
        }}>
        Advanced Filters
      </Button>

      <Collapse in={open || openFilters}>{children}</Collapse>
    </Box>
  );
};

export default AdvancedFiltersContainer;
